ymaps.ready(function(){
    var moscow_map = new ymaps.Map("yamap", {
        center: [55.76, 37.64],
        zoom: 10,
        controls: ['zoomControl']
    });

    var myPlacemark = new ymaps.Placemark([55.76, 37.64], {}, {
      iconLayout: 'default#image',
      iconImageHref: '../../images/sprites/svg/valun.svg',
      iconImageSize: [42, 42]
    });
    moscow_map.geoObjects.add(myPlacemark);
    
    myPlacemark.events.add(['click'],  function (e) {
      $('.js-main-map').addClass("__none");
      $('.js-main-info').addClass("__block");
    })
});




// WEBPACK FOOTER //
// ./src/js/general/yandex-map.js